import { graphql } from 'react-relay';

export const getDrawingSetAnnotationListQuery = graphql`
    query getDrawingSetAnnotationListQuery($input: DrawingSetAnnotationListInput!, $first: Int) {
        ...drawingSetAnnotationListFragment @arguments(input: $input, first: $first)
    }
`;
